import { render, staticRenderFns } from "./CollapseSection.vue?vue&type=template&id=596f0df8&"
import script from "./CollapseSection.vue?vue&type=script&lang=js&"
export * from "./CollapseSection.vue?vue&type=script&lang=js&"
import style0 from "./CollapseSection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports